module.exports = __webpack_public_path__ + "static/media/18ECA10.8fe3bb48.jpg";